import { render, staticRenderFns } from "./LoginSave.vue?vue&type=template&id=d9c0815c"
import script from "./LoginSave.vue?vue&type=script&lang=js"
export * from "./LoginSave.vue?vue&type=script&lang=js"
import style0 from "./LoginSave.vue?vue&type=style&index=0&id=d9c0815c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports